export default [
    {
        key: 'DistributeCustomPaymentModal',
        getComponent: function () { return import('./DistributeCustomPaymentModal'); },
        title: i18n.get('付款账户'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'AutomaticDistributeModal',
        getComponent: function () { return import('./AutomaticDistributeModal'); },
        title: i18n.get('付款账户'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
